import { useEffect, useState } from 'react'

// On Safari's first paint, localStorage can read empty for a moment before it
// finishes populating — the silent re-login in withLogin used to wait a flat 1s
// for everyone to work around it. Instead, resolve as soon as the key is
// present (the common case — non-Safari resolves on the first tick), and only
// keep waiting when it genuinely isn't there yet, capped so a logged-out
// session (key never appears) still proceeds. Strictly faster than the flat
// wait and never proceeds before the stored value is readable.
export const STORAGE_READY_CAP_MS = 1000
export const STORAGE_POLL_INTERVAL_MS = 100

const useStorageReady = (key = 'user'): boolean => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let elapsed = 0
    let timer: ReturnType<typeof setTimeout>
    const check = () => {
      if (
        localStorage.getItem(key) !== null ||
        elapsed >= STORAGE_READY_CAP_MS
      ) {
        setReady(true)
        return
      }
      elapsed += STORAGE_POLL_INTERVAL_MS
      timer = setTimeout(check, STORAGE_POLL_INTERVAL_MS)
    }
    check()

    return () => clearTimeout(timer)
  }, [key])

  return ready
}

export default useStorageReady
